/**
 * It takes in a name, label, value, and checked and returns an object with an error key and an
 * errorShowModal key.
 * @param name - the name of the input field
 * @param label - The label of the input field
 * @param value - the value of the input
 * @param checked - boolean
 * @returns An object with the following properties:
 * error: true or false
 * errorShowModal: true or false
 * headMsg: string
 * bodyMsg: string
 */
export const inputValidator = async (name, label, value, checked) => {
/**
 * It returns an object with an error property set to true if the valueGet parameter is equal to false,
 * "No Country", "", undefined, or false. Otherwise, it returns an object with an error property set to
 * false.
 * @param valueGet - the value of the input field
 * @param label - The label of the input field
 * @returns An object with two properties.
 */
  const validateInputs = (valueGet, label) => {
    if (
      valueGet === "false" ||
      valueGet === "No Country" ||
      valueGet === "" ||
      valueGet === undefined ||
      valueGet === false
    ) {
      return {
        error: true,
        errorShowModal: true,
        headMsg: "Warning",
        bodyMsg:
          "Please the following fields are required: <b>" + label + "</b>",
      };
    }
    return {
      error: false,
    };
  };

  switch (name) {
    case "eventDate":
      return validateInputs(value, label);
      
    case "storyTitle":
      return validateInputs(value.trim(), label);
      
    case "storyBody":
      return validateInputs(value, label);
      
    case "dropSubmit":
      return validateInputs(value, " Submit at least 1 Photo");
      
    case "country":
      return validateInputs(value, label);
      
    case "state":
      return validateInputs(value, label);
      
    case "termsCheck":
      return validateInputs(checked, "Agree Contest Constitutes");
    case "instagramUser":
      return validateInputs(value.trim(), " Instagram User");  
    default:
      return {
        error: false,
      };
  }
};
